'use strict';

var _ = require('lodash');
var SystemStatusReoptimizationTransformerFactory = function SystemStatusReoptimizationTransformerFactory($rootScope, DataTransformer, momentService, UserProcessingTransformationService) {
  function SystemStatusReoptimizationTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'system-reoptimization-status-mode';
    this.priority = 1;
  }
  SystemStatusReoptimizationTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusReoptimizationTransformer.constructor = SystemStatusReoptimizationTransformer;
  SystemStatusReoptimizationTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SystemStatusReoptimizationTransformer.prototype.isCacheable = function () {
    return false;
  };
  SystemStatusReoptimizationTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SystemStatusReoptimizationTransformer.prototype.transform = function (data) {
    var length = data && data.domain && data.domain.length || 0;
    for (var i = 0; i < length; i++) {
      var entry = data.domain[i];
      entry.optGroupDateMoment = momentService.of(entry.localOptGroupDateString, momentService.FIELD.OPT_GROUP_DATE);
      if (entry.previousProcessingDay) {
        entry.previousScore = entry.previousProcessingDay.score;
        entry.previousStatus = entry.previousProcessingDay.status;
        entry.previousProcessingStartDate = momentService.of(entry.previousProcessingDay.processingStartDate, momentService.FIELD.CREATED_DATE);
        entry.previousProcessingEndDate = momentService.of(entry.previousProcessingDay.processingEndDate, momentService.FIELD.CREATED_DATE);
        entry.previousUser = prepareFirstUserName(entry.previousProcessingDay.users);
        entry.previousUsers = entry.previousProcessingDay.users;
      }
      if (entry.currentProcessingDay) {
        entry.currentScore = entry.currentProcessingDay.score;
        entry.currentPriority = entry.currentProcessingDay.priority;
        entry.currentStatus = entry.currentProcessingDay.status;
        entry.currentCreationDate = momentService.of(entry.currentProcessingDay.creationDate, momentService.FIELD.CREATED_DATE);
        entry.currentProcessingStartDate = momentService.of(entry.currentProcessingDay.processingStartDate, momentService.FIELD.CREATED_DATE);
        entry.currentUser = prepareFirstUserName(entry.currentProcessingDay.users);
        entry.currentUsers = entry.currentProcessingDay.users;
        entry.currentOptLock = entry.currentProcessingDay.optLock;
      }
    }
    return data.domain;
  };
  function prepareFirstUserName(usersList) {
    return UserProcessingTransformationService.getUserDisplayName(usersList[0]) + addDots(usersList);
  }
  function addDots(usersList) {
    return _.size(usersList) > 1 ? ', ...' : '';
  }
  return SystemStatusReoptimizationTransformer;
};
SystemStatusReoptimizationTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = SystemStatusReoptimizationTransformerFactory;